import { render } from "./ProcessingBatch.vue?vue&type=template&id=ab424348&scoped=true"
import script from "./ProcessingBatch.vue?vue&type=script&lang=js"
export * from "./ProcessingBatch.vue?vue&type=script&lang=js"

import "./ProcessingBatch.vue?vue&type=style&index=0&id=ab424348&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab424348"]])

export default __exports__